import { render, staticRenderFns } from "./SecurityContact.vue?vue&type=template&id=4680ef3e"
import script from "./SecurityContact.vue?vue&type=script&lang=js"
export * from "./SecurityContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports